module.exports = {"141129100":"宁乡镇","141129101":"金罗镇","141129102":"枝柯镇","141129103":"武家庄镇","141129104":"暖泉镇","141129201":"下枣林乡","141129202":"车鸣峪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141129.json
// module id = 345
// module chunks = 0